import axios from '../axios'

/*
 * 菜单管理模块
 */

// 保存
export const save = (data) => {
  return axios({
    url: '/sysMenu/save',
    method: 'post',
    data
  })
}
// 列表
export const list = (data) => {
  return axios({
    url: '/sysMenu/list',
    method: 'post',
    data
  })
}
// 编辑
export const edit = (data) => {
  return axios({
    url: '/sysMenu/edit',
    method: 'post',
    data
  })
}
// 查看
export const view = (data) => {
  return axios({
    url: '/sysMenu/view',
    method: 'post',
    data
  })
}
// 删除
export const batchDelete = (data) => {
  return axios({
    url: '/sysMenu/delete',
    method: 'post',
    data
  })
}
// 左侧导航菜单树
export const findNavTree = (params) => {
  return axios({
    url: '/sysMenu/findNavTree',
    method: 'post',
    params
  })
}
//菜单图标
export const selectMenuIcons = (params) => {
  return axios({
    url: '/sysMenu/selectMenuIcons',
    method: 'post',
    params
  })
}
//查找children
export const findChildren = (data) => {
  return axios({
    url: '/sysMenu/findChildren',
    method: 'post',
    data
  })
}
// 上移
export const moveUp = (data) => {
  return axios({
    url: '/sysMenu/moveUpNode',
    method: 'post',
    data
  })
}
// 下移
export const moveDown = (data) => {
  return axios({
    url: '/sysMenu/moveDownNode',
    method: 'post',
    data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/menu.js